import React from 'react';
import MultiStepper from './MultiStepper';
import Navbar from '../Shared/Navbar';
import logoB from '../../assets/tripaide-logo-b.svg';

const Signup = () => {
  return (
    <div>
      <Navbar />
      <div className='md:w-3/5 mx-8 md:mx-auto my-8 xl:mt-16 p-8 pt-16 border-2 border-gray-200 shadow-lg rounded-lg'>
        <div className='flex flex-col items-center'>
          <img className='block w-1/2' src={logoB} alt="main logo" />
          <h1 className='mt-8 mb-16 text-xl font-semibold text-yellow-500'>Please Fill Up The Form To Sign Up</h1>
        </div>
        <MultiStepper />
      </div>
    </div>
  );
};

export default Signup;